import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Checkbox,
  Label,
  Stack,
} from '@shared/ui';

export function CheckboxShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.primitives.checkbox.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.primitives.checkbox.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Stack gap="sm" className="space-y-3">
          <div className="flex items-center gap-2">
            <Checkbox id="ui-library-checkbox-default" />
            <Label htmlFor="ui-library-checkbox-default">
              {t('uiLibrary.primitives.checkbox.unchecked')}
            </Label>
          </div>
          <div className="flex items-center gap-2">
            <Checkbox id="ui-library-checkbox-checked" defaultChecked />
            <Label htmlFor="ui-library-checkbox-checked">
              {t('uiLibrary.primitives.checkbox.checked')}
            </Label>
          </div>
        </Stack>
      </CardContent>
    </Card>
  );
}
